export default "__VITE_ASSET__348a9c9d__"